module.exports = __webpack_public_path__ + "static/media/martina.bfa06fc5.jpg";